export enum IvrTypificationTemplateTypeEnum {
    SERVICE_CODES = 'SERVICE_CODES',
    COMMERCIAL = 'COMMERCIAL',
    CHILD_SUB_TYPIFICATION = 'CHILD_SUB_TYPIFICATION',
}

export interface IIvrTypificationBase {
    id: string;
    loadIdentifier: string;
    typificationType: IvrTypificationTemplateTypeEnum;
    initialProcessName: string;
    processCode: string;
    typificationCode: string;
    initialTypification: string;
    subTypificationCode: string;
    initialSubTypificationName: string;
    childSubTypificationCode: string;
    childSubTypificationName: string;
    pqrstType: string;
    customerType: string;
    responseTime: string;
    active: boolean;
    createdBy?: {
        id: string;
        name: string;
        surname: string;
    };
    created_at: Date | string;
    updated_at: Date | string;
}

export interface ISelectIvrTypificationBase {
    page?: number;
    limit?: number;
    initialProcessName?: string;
    processCode?: string;
    typificationType?: IvrTypificationTemplateTypeEnum | '';
    typificationCode?: string;
    initialTypification?: string;
    subTypificationCode?: string;
    initialSubTypificationName?: string;
    pqrstType?: string;
    customerType?: string;
    responseTime?: string;
    active?: string;
}

export interface IExportTemplateIvrTypificationBase {
    typificationType: IvrTypificationTemplateTypeEnum;
}
